<template>
  <i-page class="dialog-details dialog-details-p">
    <div class="dialog-details-title">{{pageTitle}}</div>
    <q-form @submit="save" @reset="reset" ref="form">
      <div class="dialog-details-body">
        <div class="dialog-details-panel">
          <!-- <div class="dialog-details-title">用户信息</div> -->
          <div class="row-item2">
            <i-field v-model="model.name" label="站点名称" field-type="text" prepend-icon="place" :rules="[rules.required]"></i-field>
            <i-field v-model="model.type" label="站点类型" field-type="enum"  prepend-icon="place" enum="ComponentType" :rules="[rules.required]"></i-field>
            <!-- <i-field v-model="model.workId" label="ID" field-type="text" prepend-icon="person" :disable="isEditMode"></i-field> -->
            <!-- <i-field label="初始密码" field-type="text" value="*" prepend-icon="password" disable></i-field> -->
          </div>
          <div class="row-item" style="position: relative;">
            <span class="label">采血类型<span class="required">*</span></span>
            <q-checkbox v-model="selection" :val="1" label="全血" :rules="[rules.required]"/>
            <q-checkbox v-model="selection" :val="2" label="成分血" :rules="[rules.required]"/>
            <div v-if="selectionTip" style="position: absolute; bottom:-10px;left: 100px;font-size:12px;color: rgb(193,0,21);" class="selectiontip">* 请选择采血类型</div>
          </div>
          <div class="row-item" style="position: relative;">
            <span class="label">采血方式<span class="required">*</span></span>
            <q-radio v-model="model.collectType" :val="1" label="机采" :rules="[rules.required]"/>
            <q-radio v-model="model.collectType" :val="2" label="人工" :rules="[rules.required]"/>
            <div v-if="collectTypeTip" style="position: absolute; bottom:-10px;left: 100px;font-size:12px;color: rgb(193,0,21);" class="collectTypetip">* 请选择采集方式</div>
          </div>
          <div class="row-item" style="position: relative;">
            <span class="label">工作时间<span class="required">*</span></span>
            <a-time-picker v-model="model.workTimeStart"  valueFormat="HH:mm" format="HH:mm" :getPopupContainer="triggerNode => { return triggerNode.parentNode }" :rules="[rules.required]"/>
            <span> - </span>
            <a-time-picker v-model="model.workTimeEnd" valueFormat="HH:mm" format="HH:mm" :getPopupContainer="triggerNode => { return triggerNode.parentNode }" :rules="[rules.required]"/>
            <div v-if="workTimeTip" style="position: absolute; bottom:-19px;left: 100px;font-size:12px;color: rgb(193,0,21);" class="selectiontip">* 请选择工作时间</div>
          </div>
          <!-- <div class="row-item">
            <span class="label">位置<span class="required">*</span></span>
            <i-btn label="获取位置" color="primary" @click="getLocation()" />
          </div> -->
          <div class="row-item">
            <i-field v-model="model.traffic" label="交通" field-type="text" prepend-icon="subway" :rules="[rules.required]"></i-field>
          </div>
          <div class="row-item">
            <span class="label">关怀服务</span>
            <q-checkbox v-model="wifi" label="wifi" />
            <q-checkbox v-model="food" label="餐食" />
            <q-checkbox v-model="souvenir" label="纪念品" />
          </div>
        </div>
      </div>

      <div class="dialog-details-actions">
        <i-btn label="取消" color="action-cancel" icon="cancel" @click="cancel()" />
        <q-space></q-space>
        <i-btn label="确定" color="action-save" icon="save" type="submit" :disabled="loading" @click="save"></i-btn>
      </div>
    </q-form>
    <q-dialog v-model='dialogs.map.show' persistent>
      <!-- <b-map /> -->
    </q-dialog>
  </i-page>
</template>
<script>
import utils from '@/lib/utils'
import rules from '@/lib/rules.js'
import { AppPageMixin, StoreBisAuthorizeMixin, PickUsersMixin } from '@/lib/mixins'
// import BMap from './BMap.vue'

export default {
  mixins: [AppPageMixin, StoreBisAuthorizeMixin, PickUsersMixin],
  components: {
    // BMap
  },
  data () {
    return {
      utils,
      rules,
      selectionTip: false,
      collectTypeTip: false,
      workTimeTip: false,
      loading: false,
      selection: [], // 选择的血液类型
      wifi: false,
      food: false,
      souvenir: false,
      model: {
        id: null,
        name: null,
        type: null,
        collectType: 1,
        workTimeStart: null,
        workTimeEnd: null,
        traffic: '',
        position: '231231231',
        state: 1
      },
      dialogs: {
        map: {
          show: false
        }
      }
    }
  },
  props: {
    editModel: Object,
    mode: {
      type: String,
      require: true,
      validator (val) {
        return ['add', 'edit'].includes(val)
      }
    }
  },
  computed: {
    isAddMode () {
      return this.mode === 'add'
    },
    isEditMode () {
      return this.mode === 'edit'
    },
    pageTitle () {
      return `${this.isAddMode ? '新增' : '修改'}采血点信息`
    }
  },
  async mounted () {
    if (this.isEditMode) {
      this.reset()
    }
  },
  watch: {
    selection (newVal) {
      if (newVal.length === 0) {
        this.selectionTip = true
      } else {
        this.selectionTip = false
      }
    },
    'model.collectType': {
      handler (newVal) {
        if (newVal) {
          this.collectTypeTip = false
        } else {
          this.collectTypeTip = true
        }
      },
      immediate: false
    },
    'model.workTimeStart' (newVal) {
      if (!newVal) {
        this.workTimeTip = true
      } else {
        if (this.model.workTimeEnd) {
          this.workTimeTip = false
        } else {
          this.workTimeTip = true
        }
      }
    },
    'model.workTimeEnd' (newVal) {
      if (!newVal) {
        this.workTimeTip = true
      } else {
        if (this.model.workTimeStart) {
          this.workTimeTip = false
        } else {
          this.workTimeTip = true
        }
      }
    }
  },
  methods: {
    getLocation () {
      this.dialogs.map.show = true
    },
    reset () {
      if (this.isAddMode) {
        utils.reset(this.model, { state: 1, collectType: 1 })
      } else {
        utils.reset(this.model, this.editModel)
        if (this.editModel.bloodType !== 3) {
          this.selection.push(this.editModel.bloodType)
        } else {
          this.selection = [1, 2]
        }
        const careServices = JSON.parse(this.editModel.careServices)
        this.wifi = !!careServices.wifi
        this.food = !!careServices.food
        this.souvenir = !!careServices.souvenir
      }
      this.$refs.form.resetValidation()
    },
    async save () {
      const valid = await this.$refs.form.validate()
      if (!valid) return
      if (this.selection.length === 0) {
        this.selectionTip = true
        return
      }
      if (!this.model.collectType) {
        this.collectTypeTip = true
        return
      }
      if (!this.model.workTimeEnd || !this.model.workTimeStart) {
        this.workTimeTip = true
        return
      }
      this.loading = true
      const params = {
        ...this.model
      }
      if (this.selection.length) {
        if (this.selection.length === 1) {
          params.bloodType = this.selection[0]
        } else if (this.selection.length === 2) {
          params.bloodType = 3
        }
      }
      const careServices = {
        wifi: this.wifi ? 1 : 0,
        food: this.food ? 1 : 0,
        souvenir: this.souvenir ? 1 : 0
      }
      params.careServices = JSON.stringify(careServices)
      params.position = '34523453453434'
      let result
      if (this.isAddMode) {
        result = await this.$$api.bis.post('/collectPoint/', params)
        result.notifyIfFail()
        result.notify(result.success ? '添加成功' : null)
      } else {
        result = await this.$$api.bis.put(`/collectPoint/${params.id}`, params)
        result.notifyIfFail()
        result.notify(result.success ? '修改成功' : null)
      }
      if (result.success) {
        if (this.isAddMode) {
          this.reset()
        }
        this.$emit('saved')
      }
      this.loading = false
    },
    cancel () {
      if (this.isEditMode) {
        this.$q.dialog({
          message: '<span style="font-weight: 700">尚未保存，确认退出吗?</span>',
          cancel: { color: 'grey' },
          html: true,
          ok: { color: 'blue' },
          focus: 'cancel'
        }).onOk(async () => {
          this.$emit('cancel')
        })
      } else {
        this.$emit('cancel')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .label {
    margin-right: 20px;
    font-size: 16px;
    font-weight: 700;
  }
  .required {
    color: rgb(229,83,72);
  }
  .row-item {
    margin-bottom: 20px;
  }
</style>
